// extracted by mini-css-extract-plugin
module.exports = {"subheader":"_4f720283bf--subheader--JmFc3"};